import React from 'react';
import { ReferenceCard } from '../../components/ReferenceCard/ReferenceCard';
import { useHistory } from 'react-router-dom';
import getCardDetails from '../../util/getCardDetails';
import { Button } from 'dw-us-ui';

const ReferenceCardWrapper = ({ refCard, brand }) => {
  const history = useHistory();
  let cardDetails = getCardDetails(refCard?.blocks);

  const hasButtonTitle = 'Discover';

  const buttonLinkComponent = (
    <span
      onClick={() => {
        history.push(`/${cardDetails?.url}`);
      }}
    >
      <Button brand={brand} buttonType="primary" buttonSize="small" className={`${brand.toLowerCase()}`}>
        {hasButtonTitle}
      </Button>
    </span>
  );

  return (
    <div className="h-100" data-testid="reference-card-wrapper">
      <ReferenceCard cardDetails={cardDetails}>{buttonLinkComponent}</ReferenceCard>
    </div>
  );
};

export { ReferenceCardWrapper };
